import {css} from "styled-components";

const ProductCss = css`
  .strikeout-hr {
    padding: 0;
    width: 110%;
    border-width: 1px;
    transform: rotate(-10deg);
    mix-blend-mode: multiply;
    margin: 0 auto -.7em -.2em;
  }
  
  .unavailable-wrapper {
    border: 1px dashed gray;
  }
  
  .unavailable {
    opacity: 0.4;
  }
`;

export default ProductCss;
